const GraphSrcSetImage = ({ srcSet, ...props }) => {
    const convertToWebP = (set) => {
        return set.replace(/\.jpg/g, '.jpg.webp');
    };

    return (
        <picture suppressHydrationWarning>
            <source type="image/webp" srcSet={convertToWebP(srcSet)} />
            <img suppressHydrationWarning srcSet={srcSet} {...props} />
        </picture>
    );
}

export default GraphSrcSetImage;